import React from 'react';
import {
  ShopStatus as ShopStatusStyled,
  RatingAndStars,
  RatingNumber,
  MaxMark,
  RatingHeading
} from './ShopStatus.styles';
import { ShopStatusProps } from 'models/ShopStatusProps';
import CertificationState from 'components/ShopResultItem/CertificationState/CertificationState';
import { useIntl } from 'react-intl';
import { Stars } from '@trustedshops/tps-seo-shared-frontend-react-components';

const ShopStatus = ({
  shop,
  showRatingAndStars,
  showCertificateState
}: ShopStatusProps) => {
  const { formatMessage } = useIntl();
  const maxMark: string = '5.00';

  return (
    <ShopStatusStyled>
      {showRatingAndStars && (
        <>
          <RatingAndStars>
            <RatingHeading as="span" $lookAlike="h3">
              {shop.averageRating.toFixed(2)}
            </RatingHeading>
            <MaxMark>/{maxMark}</MaxMark>
            <Stars filledValue={shop.averageRating} />
          </RatingAndStars>
          <RatingNumber $hasCertification={showCertificateState}>
            {formatMessage(
              { id: 'SHOP_CARD.NUMBER_REVIEWS' },
              { count: shop.reviewCount }
            )}
          </RatingNumber>
        </>
      )}
      {showCertificateState && (
        <CertificationState certificationState={!!shop.certificationState} />
      )}
    </ShopStatusStyled>
  );
};

export default ShopStatus;
